// 生 ChakraBadge を import できるのは lint の許可リスト (@ebalance/eslint-config の
// react-app.cjs) に載ったカテゴリカル専用部品だけ。 本ファイルはその 1 つ。
import { ChakraBadge } from '@enechain/ecloud-designsystem'

import type { BlockKind } from '~/pages/SpotBidding/models/blockBidRow'

/**
 * ブロック leg 種別 → 識別色 (= design `#block-bid-body` の badge 配色)。
 *
 * ブロック種別はペア構造の識別 (どの leg か) であって状態の重要度ではないため、
 * semantic status ではなくカテゴリカル配色を使う (LOOP-A = negative は嘘の意味に
 * なる)。
 */
const LEG_KIND_COLOR_PALETTE: Record<BlockKind, string> = {
  STANDARD: 'gray',
  'LINK-P': 'purple',
  'LINK-C': 'purple',
  'LOOP-A': 'red',
  'LOOP-B': 'green',
}

/**
 * ブロック入札一覧の leg 種別バッジ。 色マップをこの部品に閉じ込め、 色を外から渡す口は
 * 公開しない。
 *
 * `fontSize="md"` は ecloud Table の size recipe が Badge を 10px に縮めるのを design の
 * 14px に戻すためのもの (= 表内の他セルと同じ扱い)。
 */
export const BlockLegKindBadge = ({
  kind,
}: {
  kind: BlockKind
}): React.ReactElement => (
  <ChakraBadge fontSize="md" colorPalette={LEG_KIND_COLOR_PALETTE[kind]}>
    {kind}
  </ChakraBadge>
)
